import type { IconNode } from '../types';

/**
 * @name sweater
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNNiAxOUgzYy0uNiAwLTEtLjQtMS0xVjZjMC0xLjEuOC0yLjMgMS45LTIuNkw4IDJhNCA0IDAgMCAwIDggMGw0LjEgMS40QzIxLjIgMy43IDIyIDQuOSAyMiA2djEyYzAgLjYtLjQgMS0xIDFoLTMiIC8+CiAgPHBhdGggZD0iTTE4IDh2MTNjMCAuNi0uNCAxLTEgMUg3Yy0uNiAwLTEtLjQtMS0xVjgiIC8+CiAgPHBhdGggZD0ibTYgMTAgMiAyIDItMiAyIDIgMi0yIDIgMiAyLTIiIC8+CiAgPHBhdGggZD0ibTYgMTYgMiAyIDItMiAyIDIgMi0yIDIgMiAyLTIiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/sweater
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const sweater: IconNode = [
  [
    'path',
    {
      d: 'M6 19H3c-.6 0-1-.4-1-1V6c0-1.1.8-2.3 1.9-2.6L8 2a4 4 0 0 0 8 0l4.1 1.4C21.2 3.7 22 4.9 22 6v12c0 .6-.4 1-1 1h-3',
      key: '9k6art',
    },
  ],
  ['path', { d: 'M18 8v13c0 .6-.4 1-1 1H7c-.6 0-1-.4-1-1V8', key: '2ru6tq' }],
  ['path', { d: 'm6 10 2 2 2-2 2 2 2-2 2 2 2-2', key: 'fk3thp' }],
  ['path', { d: 'm6 16 2 2 2-2 2 2 2-2 2 2 2-2', key: '13bq4g' }],
];

export default sweater;
